/**
 *
 * Scrolls to an element with an id inside a container.
 *
 * TODO: rename function because of a name conflict with JavaScript native scrollTo function
 *
 * @author Juhana Kuparinen <juhana.kuparinen@kvanttori.fi>
 */

export default function scrollTo(container: string, id: string) {
  const myElement = document.getElementById(id);
  const topPos = myElement?.offsetTop ?? 0;
  const parent = document.querySelector(container);
  if (parent) parent.scrollTop = topPos;
}
